export default __webpack_public_path__ + "static/media/snow.ceaeea43.png";